import * as React from 'react';

import { Shimmer } from '../../../../../../../../common/Shimmer';
import { AnimationElement } from '../../../../../../../../common/Animation';

import { TooltipAnimationConfig } from './constants';
import * as styles from './BetPositionTooltip.css';

interface IProps {
  loading: boolean;
  children: React.ReactNode;
}

export const BetPositionTooltip = ({ loading, children }: IProps) => (
  <div className={styles['tooltip']}>
    <AnimationElement {...TooltipAnimationConfig}>
      <Shimmer theme="black" running={loading}>
        <div className={styles['content']}>{children}</div>
      </Shimmer>
    </AnimationElement>
  </div>
);
